import { REVIEW_FORM_KEYS } from 'reducers/reviewFormSlice';

import CompetencyForm from '../../CompetencyForm/CompetencyForm';
import GoalForm from '../../GoalForm/GoalForm';
import OverallQuestionsForm from '../../OverallQuestionsForm/OverallQuestionsForm';

const REVIEW_FORM_TYPES = {
  [REVIEW_FORM_KEYS.COMPETENCY]: {
    id: REVIEW_FORM_KEYS.COMPETENCY,
    title: 'Competencies', // <- used in sidebar
    displayName: 'Competencies', // <- used in header of right content
    component: CompetencyForm,
    title1: 'Competency',
    titlePlural: 'Competencies',
  },
  [REVIEW_FORM_KEYS.QNA]: {
    id: REVIEW_FORM_KEYS.QNA,
    title: 'Q&A',
    displayName: 'Q&A',
    component: OverallQuestionsForm,
    title1: 'Q&A',
    titlePlural: 'Q&A',
  },
  [REVIEW_FORM_KEYS.GOAL]: {
    id: REVIEW_FORM_KEYS.GOAL,
    title: 'Goals',
    displayName: 'Goals Review',
    component: GoalForm,
    title1: 'Goal',
    titlePlural: 'Goals',
  },
};

export default REVIEW_FORM_TYPES;
